import { render, staticRenderFns } from "./Product11-01-003-000012ogmmr.vue?vue&type=template&id=8c10b03c"
import script from "./Product11-01-003-000012ogmmr.vue?vue&type=script&lang=js"
export * from "./Product11-01-003-000012ogmmr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c10b03c')) {
      api.createRecord('8c10b03c', component.options)
    } else {
      api.reload('8c10b03c', component.options)
    }
    module.hot.accept("./Product11-01-003-000012ogmmr.vue?vue&type=template&id=8c10b03c", function () {
      api.rerender('8c10b03c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/deposit/Product11-01-003-000012ogmmr.vue"
export default component.exports